import styled from "styled-components";

export const Wrapper = styled.div`
  button {
    white-space: nowrap;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Debrief/components/DebriefFooter/style.js